import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Form, Input, Label, Segment, Select, Tab } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

interface Props {
  metadataComponent: any[];
  communicationMsgStr: string;
  communicationSubStr: string;
}

function CardBox({
  metadataComponent,
  communicationMsgStr,
  communicationSubStr,
}: Props) {
  const {
    RolesAndPermissionsStore,
    CommunicationSettingStore,
    ApiStore: { templateMetadataElement },
  } = useStore();
  const { getmasterCommunication } = CommunicationSettingStore;
  const { loadRoles, rolesByName } = RolesAndPermissionsStore;

  useEffect(() => {
    if (rolesByName.length <= 1) loadRoles();
  }, [rolesByName.length, loadRoles]);

  useEffect(() => {
    nativeBindDraggable();
    nativeBindWriteRegion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const attachInput = (e: string) => {
    CommunicationSettingStore.updateCommunicationInput('attachment', e);
  };

  const getRoleVal = (e: any, data: any) => {
    CommunicationSettingStore.updateCommunicationInput(
      'userRolesId',
      data.value,
    );
  };

  const updateMsgAndSub = (param?: string) => {
    let arrPus: any = [];
    const currentMsg =
      document.querySelector('.msg-communication')?.innerHTML || '';
    const currentSub =
      document.querySelector('.sub-communication')?.innerHTML || '';

    // ===== model =====
    if (param) {
      const tabContainer: any = document.querySelector(param);
      const elementTag = tabContainer.querySelectorAll('C');
      elementTag.forEach((data: any) => {
        // eslint-disable-next-line
        arrPus.push(
          '"' +
            data.textContent.slice(1, -1).replace(/ /g, '_') +
            '"' +
            ':' +
            '"' +
            data.id +
            '"',
        );
      });
      if (param === '.msg-communication') {
        let model = '{' + arrPus + '}';
        CommunicationSettingStore.updateCommunicationInput('model', model);
      } else if (param === '.sub-communication') {
        let modelSub = '{' + arrPus + '}';
        CommunicationSettingStore.updateCommunicationInput(
          'modelSub',
          modelSub,
        );
      }
    }
    CommunicationSettingStore.updateCommunicationInput('message', currentMsg);
    CommunicationSettingStore.updateCommunicationInput('subject', currentSub);
  };

  const optionList = () => {
    return rolesByName.map((data: any) => ({
      key: data.roleName,
      text: data.roleName,
      value: data.id,
    }));
  };

  const getSelectedRole = () => {
    return getmasterCommunication?.[0]?.userRolesId || '';
  };

  // ... (previous code)

  const addClass = (elem: any, className: any) => {
    const classNames = elem.className.split(' ');
    if (classNames.indexOf(className) === -1) {
      classNames.push(className);
    }
    elem.className = classNames.join(' ');
  };

  const selectAllElems = (selector: any) => {
    return document.querySelectorAll(selector);
  };

  const nativeBindDraggable = (elems: any = false) => {
    elems = elems || selectAllElems('.native_drag');
    if (!elems) {
      // No element exists, abort
      return false;
    } else if (elems.outerHTML) {
      // if only a single element, put in array
      elems = [elems];
    }

    for (let i = 0; i < elems.length; i++) {
      elems[i].dataset.transferreference = `transit_${new Date().getTime()}`;
      elems[i].ondragstart = function (e: any) {
        const globalWin: any = window;
        globalWin.inTransferMarkup = e.target.outerHTML;
        globalWin.transferreference = elems[i].dataset.transferreference;
        addClass(e.target, 'dragged');
      };
    }
  };

  const nativeBindWriteRegion = (elems: any = false) => {
    elems = elems || selectAllElems('.native_receiver');
    if (!elems) {
      // No element exists, abort
      return false;
    } else if (elems.outerHTML) {
      // if only a single element, put in array
      elems = [elems];
    }

    for (let i = 0; i < elems.length; i++) {
      elems[i].ondragover = function (e: any) {
        e.preventDefault();
        return false;
      };
      elems[i].ondrop = function (e: any) {
        receiveBlock(e);
      };
    }
  };

  // ... (previous code)

  const receiveBlock = (e: any) => {
    e.preventDefault();
    const globalWin: any = window;
    const content = globalWin.inTransferMarkup;

    globalWin.inTransferMarkup = '';

    let range = null;
    if (document.caretRangeFromPoint) {
      // Chrome
      range = document.caretRangeFromPoint(e.clientX, e.clientY);
    } else if (e.rangeParent) {
      // Firefox
      range = document.createRange();
      range.setStart(e.rangeParent, e.rangeOffset);
    }
    const sel: any = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    e.target.focus();

    document.execCommand('insertHTML', false, content);
    sel.removeAllRanges();

    // reset draggable on all blocks, esp the recently created
    nativeBindDraggable(
      document.querySelector(
        `[data-transferreference='${globalWin.transferreference}']`,
      ),
    );
    updateMsgAndSub('.msg-communication');
    updateMsgAndSub('.sub-communication');
    return false;
  };

  // ... (rest of your code)

  return (
    <Tab.Pane>
      <Segment.Group className="CardBox-Container">
        <Segment compact>
          <div className="split">
            <label>Subject Content</label>
            <div
              className="text msg-communication native_receiver"
              // placeholder="Subject Content"
              contentEditable="true"
              style={{
                height: '70vh',
                width: '70vw',
                color: 'black',
                border: '0px',
              }}
              dangerouslySetInnerHTML={{
                __html: communicationMsgStr,
              }}
              onKeyUp={() => {
                updateMsgAndSub('.msg-communication');
              }}
              suppressContentEditableWarning={true}
            ></div>
            <div className="fields">
              {/* <CsCardBox selectedElementDat={selectedElementDat} roleValueData={roleValueData}/>           */}
              <Segment>
                <Segment>
                  <Label.Group color="grey" size="medium">
                    <Label as="a" style={{ width: '100%' }}>
                      <p>Subject:</p>
                      {/* <Input style={{width: '100%'}} onChange = {(e:any) => subjectInput(e.target.value)} placeholder="Enter Your Subject" value={commScheme !== undefined? commScheme.subject: ''}/> */}
                      <div
                        contentEditable="true"
                        className="sub-communication native_receiver"
                        // placeholder="Enter the Subject..."
                        dangerouslySetInnerHTML={{
                          __html: communicationSubStr,
                        }}
                        onKeyUp={() => {
                          updateMsgAndSub('.sub-communication');
                        }}
                        suppressContentEditableWarning={true}
                      ></div>
                    </Label>
                    <Label as="a" style={{ width: '100%' }}>
                      <p>User Role:</p>
                      <Form.Field
                        control={Select}
                        style={{ width: '100%' }}
                        placeholder="Select Role"
                        search
                        selection
                        options={optionList()}
                        value={getSelectedRole()}
                        onChange={(e: any, data: any) => getRoleVal(e, data)}
                      />
                    </Label>

                    <Label as="a" style={{ width: '100%' }}>
                      <p>Attachment:</p>
                      <Input
                        style={{ width: '100%' }}
                        onChange={(e: any) => attachInput(e.target.value)}
                        placeholder="Enter file format (eg: .doc, .jpg)"
                        value={
                          getmasterCommunication !== undefined
                            ? getmasterCommunication?.[0]?.attachment === null
                              ? ''
                              : getmasterCommunication?.[0]?.attachment
                            : ''
                        }
                      />
                    </Label>
                  </Label.Group>
                </Segment>

                <Segment>
                  <Label.Group color="grey" size="medium">
                    {!!metadataComponent &&
                      metadataComponent.map((data: any) => {
                        return (
                          <>
                            <h5>WorkFlow Components:</h5>
                            <Label
                              as="c"
                              key={data.value}
                              className="native_drag"
                              data-type="dateselector"
                              contentEditable="false"
                              draggable="true"
                              id={data.value}
                            >
                              {' '}
                              {data.text.replace(/ /g, '_')}{' '}
                            </Label>
                          </>
                        );
                      })}
                  </Label.Group>
                </Segment>
                <Segment>
                  <Label.Group color="blue" size="medium">
                    <h5>Meta Data Components:</h5>
                    {templateMetadataElement.map((a: any) => (
                      <Label
                        as="c"
                        key={a.key}
                        className="native_drag"
                        data-type="dateselector"
                        contentEditable="false"
                        suppressContentEditableWarning={false}
                        draggable="true"
                        id={a.key}
                      >
                        {a.text}
                      </Label>
                    ))}
                  </Label.Group>
                </Segment>
              </Segment>
            </div>
          </div>
        </Segment>
      </Segment.Group>
    </Tab.Pane>
  );
}

export default observer(CardBox);
